'use client'

import { ImageWithFallback } from '~/components/ImageWithFallback'
import { NFTTokenBalance } from '~/types'

export const NFTImage = ({
  nft,
}: {
  nft: Pick<NFTTokenBalance, 'imageURI' | 'name' | 'address'>
}) => {
  return (
    <ImageWithFallback
      src={nft.imageURI}
      alt={`Image for ${nft.name}`}
      fallbackSrc={'/other/background.png'}
      className="h-full w-full rounded object-cover"
      width={100}
      height={100}
      unoptimized={true}
      title={nft.address}
    />
  )
}
